import React from "react";
import Logo from "../components/Logo";
import LeftSection from "../components/landing_page/LeftSection";
import AcceptInviteForm from "../components/invitation_registration/AcceptInviteForm";

const InvitationAcceptPage = () => {
  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center space-x-3">
              {/* Logo */}
              <Logo />
            </div>
          </div>
        </header>

        {/* Main Content - Two Column Grid */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className=" bg-gray-50 flex items-center justify-center">
            <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Left Section - Branding */}
              <LeftSection />
              {/* Right Section - accept Form */}
              <AcceptInviteForm />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default InvitationAcceptPage;
